<!--      --------------------Memory screen-->
<div class="popup-content memory-popup">
  <div class="popup-explanation">
    <div class="explain-pin">
       <img [draggable]="false" src="/img/games/explain-pin.svg">
    </div>
    <!-- <h3 class="header">{{audio.text.games.instruction}}</h3> -->
    <p>{{explanationText}}</p>
  </div>

  <div class="memory-wrapper">
    <div class="memory">
              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="1">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="2">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="3">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="4">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="5">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="6">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="7">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="8">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="9">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="10">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="11">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

              <div class="container">
                  <img class="memorySetfound" src="/img/checkmark.svg" draggable="false">
                <div class="card" x-card="12">
                  <img class="back" src="" draggable="false">
                </div>
              </div>

    </div>
  </div>
</div>
<!--      --------------------END Memory screen-->
